import { Stack } from "@mui/material";
import Scrollbar from "src/components/Scrollbar";
import { ActivePosition } from "src/types/products";

import RevisionItem from "./RevisionItem/RevisionItem";

// ----------------------------------------------------------------------

type Props = {
	data: ActivePosition[];
};

export const RevisionList = ({ data }: Props) => {
	return (
		<Scrollbar sx={{ height: { sm: "auto", md: 400 } }}>
			<Stack gap={2} sx={{ mt: 2, pb: 2 }}>
				{data.map((i) => (
					<RevisionItem position={i} key={i.positionId} />
				))}
			</Stack>
		</Scrollbar>
	);
};

export default RevisionList;
